import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { ConfidentialResourceAccessRequestSingle } from './ResourceTypeCell.types';

export const isConfidentialResourceAccessRequestSingle = (
   request: ConfidentialResourceAccessRequest
): request is ConfidentialResourceAccessRequestSingle => {
   return request.confidentialResources.length === 1;
};

export const isMedicalDocumentationGeneration = (request: ConfidentialResourceAccessRequest): boolean => {
   return request.resourceType === 'PATIENT_MEDICAL_DOCUMENTATION_GENERATION';
};
